import { FC, useState } from 'react';
import { ManagedCommItem } from '../../../../../../hooks/use-communications/types/managed-communication';
import { TemplateViewerDialog } from '../../../../../shared/template/template-viewer/template-viewer-dialog';
import { ManagedCommCardTitle } from '../shared/title/managed-comm-card-title';
import { ManagedCommCard, ManagedCommCardWrapper, ManagedCommSignature } from '../styles';

interface EmailManagedCommCardProps {
  communication: ManagedCommItem;
}

export const EmailMangedCommCard: FC<EmailManagedCommCardProps> = (props) => {
  const { communication } = props;
  const [viewTemplateDialogOpen, setViewTemplateDialogOpen] = useState(false);

  const handleCardClick = async () => {
    setViewTemplateDialogOpen(true);
  };

  return (
    <ManagedCommCardWrapper className="email-card">
      <ManagedCommCard>
        <ManagedCommCardTitle communication={communication} onClickOnly={handleCardClick} />
      </ManagedCommCard>
      <ManagedCommSignature communication={communication} />
      {viewTemplateDialogOpen && communication.communicationId && (
        <TemplateViewerDialog
          open={viewTemplateDialogOpen}
          communicationId={communication.communicationId}
          subject={communication.subject}
          to={communication.sentTo}
          date={communication.date}
          onClose={() => setViewTemplateDialogOpen(false)}
        />
      )}
    </ManagedCommCardWrapper>
  );
};
